<template>
	<div class="site" :class="this.isLoggedIn ? 'login' : 'logout'">


		<div>

			<!-- felmeddelanden -->
			<div v-if="hasUnReadErrorMessages"
				style="position:fixed;top:0px;margin-left:0px;z-index:100;background:var(--darker);width:100%;filter: drop-shadow(0px 5px 10px #777777);">
				<div class="center-padding center">

					<div style="padding:10px;max-height:200px;overflow:scroll;">

						<div v-for="(message, index) in unReadErrorMessages" :key="index"
							style="background:var(--bg-error);padding:5px;width:calc(100% - 10px);margin-bottom:10px;border-radius: 5px;color:var(--white)">
							{{ message.message }}
						</div>

					</div>
					<Button label="Stäng" @click="setAllMessagesRead()" style="margin:10px;margin-top:10px;margin-bottom:20px;" />

				</div>
			</div>

			<!-- side menu -->
			<div :class="this.sideMenuVisible ? 'open' : 'closed'" id="sideMenu"
				style="position:fixed;background:var(--white);height:100%;z-index:50;" @transitionend="this.sideMenuClosed()">

				<div style="padding:0px; overflow:scroll;max-height:calc(100% - 90px);">


					<div style="padding:10px;padding-top:40px;">

						<SideMenu @sideMenuVisible="((visible) => this.sideMenuVisible = visible)" />

					</div>
				</div>

			</div>

			<!-- blurar hela sidan -->
			<div v-if="this.sideMenuVisible" style="z-index:30;position:fixed;height:100%;width:100%;" class="blur"
				:class="this.sideMenuVisible ? 'blur-on' : 'blur-off'" @click="this.sideMenuVisible = false;">
			</div>


			<!-- header -->
			<div id="top-header" style="padding-top:env(safe-area-inset-top);">

				<div id="nav"
					:class="this.isMenuVisible() || isPageMenuOpen ? 'top-header-background menu-show' : 'top-header-background menu-hide'">
					<div class=" padding-top-auto" style="z-index:10;height:100%;">
						<div class="flexcenter center center-padding" style="gap:0px;max-height: 30px;">

							<!-- för att visa sidemenu, drawer -->
							<Icon v-if="!this" class="mobile" icon="bars-dark"
								style="margin-right:5px;width:20px;height:20px;border:0px solid white;"
								@click="this.sideMenuVisible = !this.sideMenuVisible" />


							<div class="flexcenter" style="gap:5px;">


								<!-- logo start logotype -->
								<div style="background:transparent;padding:0px;padding-left:0px;padding-right:10px;border-radius: 5px;"
									class="flexcenter desktop link" @click="this.routerShowStart(); this.closeMenus();">
									<img src="@/assets/logo_black.png" style="width:160px;" />
								</div>

								<div class="mobile link"
									style="background:transparent;padding:0px;border-radius:5px;border:0px solid white;line-height: 0px;"
									@click="this.routerShowStart(); this.closeMenus();">
									<img src="@/assets/logo-patch_black.png" style="width:30px;" />
								</div>


								<!-- dropdown för att välja product-type -->
								<!-- StartProductType :showProductType="this.showProductType" @showProductType="this.showProductType = true"
									@closeProductType="this.showProductType = false" @closeMenus="this.closeMenus();" / -->

								<!-- dropdown för att välja product-type -->
								<StartProductTypeButtonList :showProductType="this.showProductType"
									@showProductType="this.showProductType = true" @closeProductType="this.showProductType = false"
									@closeMenus="this.closeMenus();" />

								<!-- dropdown för att välja outlet-product-type -->
								<StartOutletPopover :showOutletProductType="this.showOutletProductType"
									@showOutletProductType="this.showOutletProductType = true"
									@closeOutletProductType="this.showOutletProductType = false" @closeMenus="this.closeMenus();" />

								<div v-if="!this" class="badge link" @click="this.routerShowProductList()"
									:title="this.productListCount">
									Produkter:
									{{
									this.productTypeModel?.selected?.name }}
								</div>


								<router-link to="/aterforsaljare" @mouseenter="this.hideAllSubmenu()"
									class="font-small menu-link"><b>Återförsäljare</b></router-link>



								<router-link v-if="this.debug" to="/test" @mouseenter="this.hideAllSubmenu()"
									class="desktop font-small menu-link"><b>Test</b></router-link>


								<b class="font-small desktop link menu-link"
									@click="this.gotoStart('start-footer'); this.closeMenus()">Kontakt</b>

								<!--b class="desktop font-small link menu-link" @click="this.outletClicked(); this.closeMenus()">{{
									this.outletLabel}}</b-->



								<a v-if="!this.isLoggedIn" class="desktop menu link font-small menu-link"
									@click.stop="toggleSubMenu('login'); this.closeMenus('login')"><b>ÅF-Login</b>
								</a>


								<a v-if="!this" class="mobile menu link font-small menu-link"
									@click.stop="toggleSubMenu('login'); this.closeMenus('login');"><b>ÅF</b>
								</a>






								<!--select v-model="this.productTypeLocal"> 
									<option v-for="productType in this.productTypeList" :key="productType.key" :value="productType" >{{ productType.name }}</option>
								</select-->


							</div>

							<div style="flex-grow:1;background:transparent;height:30px;" @click.stop="this.hideAllSubmenu()">&nbsp;
							</div>
							<span class="desktop">
								<Button v-if="this.environmentDev" class="desktop" label="Debug" @click="toggleDebug"
									:class="this.$store.state.debug ? 'debug' : 'grey'" />

								<Button v-if="unReadErrorMessages.length > 0 || this.debug || this.environmentDev" label="Error"
									:badge="unReadErrorMessages.length"
									:class="unReadErrorMessages && unReadErrorMessages.length > 0 ? 'error' : 'grey'"
									@click.stop="showSubMenu('error')" />

							</span>






							<Icon :icon="this.isUserActive ? 'reload' : 'reload-light'"
								:title="'Antal request counts: ' + requestCount" :class="requestCount == 0 ? '' : 'spinner'"
								@click="this.reloadPressed()" />

							<Circle v-if="this.isLoggedIn && this.debug" fileName="w3_logout_white" color="--bg-message" padding="15%"
								marginLeft="3px" style="margin-left:5px;" @click.stop="(() => this.toggleSubMenu('login'))" />

							<Circle v-if="this.isLoggedIn && !this.debug" fileName="w3_logout_white" color="--grey-6" padding="15%"
								marginLeft="3px" style="margin-left:5px;" @click.stop="(() => $refs.login.logout())" />


						</div>


					</div>



				</div>



				<div id="order" v-if="this.isLoggedIn" class=""
					:class="this.isMenuVisible() || isPageMenuOpen ? 'top-header-background menu-show' : 'top-header-background menu-hide' "
					style=" height:var(--order-header-height);">
					<div class="" style="z-index:10;">
						<div class="center center-padding">

							<ResellerMenu @showCurrentOrder="(() => this.showSubMenu('order'))"
								@hideAllSubmenu="(() => this.hideAllSubmenu())" @toggleSubMenu="((menu) => this.toggleSubMenu(menu))"
								:isOrderMenuVisible="this.isMenuVisible('order')" @logout="(() => $refs.login.logout())" />



						</div>
					</div>

				</div>

			</div>

			<!-- blurar content-->
			<div style="z-index:30;border:0px solid red;position:fixed;width:100%;" class="blur"
				:class="this.isMenuVisible() || this.hasUnReadErrorMessages ? 'blur-on' : 'blur-off'"
				@click="this.hideAllSubmenu(13);" @mouseenter="this.hideAllSubmenu(12)">
			</div>

			<!-- content -->
			<div style="width:100%;height:100%;" @click="this.hideAllSubmenu(15);">
				<div class="content" @mousemove="mouseMove()" :class="this.isLoggedIn ? 'login' : 'logout' ">


					<!-- router -->
					<router-view @getProductRowList="(() => {
						this.getProductRowListFromRouterView()
					} )" @getBaseModel="(() => {
						this.getBaseModelFromRouterView()
					})" @showSubMenuOrder="(() => { this.showSubMenu('order') })" @showSubMenuLogin="(() => {
							this.showSubMenu('login');
						})" @sideMenuVisible="((visible) => this.sideMenuVisible = visible)"
						@gotoStart="((section) => { this.gotoStart(section)})" />

					<!-- FP 2026 tog bort : @showProductType="this.showProductType = true" från ovan-->



				</div>



			</div>
			<!-- placera menyerna här -->




			<div :class="isMenuVisible('login') ? 'show' : 'hide'" class="submenu" style=""
				@click.self="this.hideAllSubmenu(16)">
				<div class="center-padding center" style="min-height:300px;">
					<Login class="center" style="margin-top:20px;" ref="login" @hideAllSubmenu="(() => this.hideAllSubmenu())" />

				</div>

			</div>

			<div :class="isMenuVisible('order') ? 'show' : 'hide'" class="submenu" style=""
				@click.self="this.hideAllSubmenu()">
				<div v-if="this.isLoggedIn" class="center-padding center" style="min-height:300px;">

					<div v-if="this.currentOrder && this.currentOrder.orderId > 0">

						<Order :orderId="this.currentOrder.orderId" />
					</div>





				</div>
				<LoginRequired v-if="!this.isLoggedIn" @showSubMenuLogin="(() => {
					this.showSubMenu('login');
				})" />

			</div>

			<div :class="isMenuVisible('error') ? 'show' : 'hide'" class="submenu" style=""
				@click.self="this.hideAllSubmenu()">
				<div class="center-padding center" style="min-height:300px;">

					<EventList style="max-height:200px;overflow:scroll;" />
					<Button label="Stäng" style="margin-top:10px;" @click="closeEventLogView()" />
				</div>

			</div>

		</div>
	</div>
</template>

<script>


import Login from './views/Login.vue';
import EventList from './components/event-log/EventList.vue';
import { STORE_ACTION, STORE_COMMIT, STORE_GETTER } from './store/store';

import { userMixin } from './mixins/userMixin';
import { modelMixin } from './mixins/modelMixin';
import { productMixin } from './mixins/productMixin';
import { routerMixin } from './mixins/routerMixin';
//import TestOrder from './views/test/TestOrder.vue';
import { PRODUCT_STORE_GETTER } from './store/product-store';
import Order from './components/order/Order.vue';
import ResellerMenu from './components/ResellerMenu.vue';
import SideMenu from './components/sidemenu/SideMenu.vue';
import LoginRequired from './components/user/LoginRequired.vue';
import StartOutletPopover from './components/StartOutletPopover.vue';
import StartProductTypeButtonList from './components/StartProductTypeButtonList.vue';


export default {
	name: "App",
	mixins: [userMixin, modelMixin, productMixin, routerMixin],
	components: { EventList, Login, Order, ResellerMenu, SideMenu, LoginRequired, StartOutletPopover, StartProductTypeButtonList },
	data() {
		return {

			isUserActive: true,
			sideMenuVisible: false,
			width: "1400px", // ändra i css om värdet ändras, sök 1400
			debugWidth: "1000px",
			defaultWidth: "1400px",
			showOutletProductType: false,
			menuList: [{
				name: "menu1",
				visible: false
			}, {
				name: "menu2",
				visible: false
			}, {
				name: "login",
				visible: false
			}, {
				name: "order",
				visible: false
			}, {
				name: "error",
				visible: false
			}],
			canHideAllSubMenu: true,
		

			
		}
	},
	computed: {
		requestCount() {
			return this.$store.getters[STORE_GETTER.REQUEST_COUNT]
		},

		unReadErrorMessages() {
			return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]

		},

		baseModelLoading(){
			return this.$store.getters[STORE_GETTER.BASE_MODEL_LOADING]
		},

		searchIndexModelLoading() {
			return this.$store.getters[STORE_GETTER.SEARCH_INDEX_MODEL_LOADING]
		},

		hasUnReadErrorMessages() {
			const list = this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return list && list.length > 0

		},

		orderBadge() {

			if (this.currentOrder) {
				return this.currentOrder.quantitySummary
			}

			return "--"

		},



		isPageMenuOpen() {
			return this.$store.getters[STORE_GETTER.IS_PAGE_MENU_OPEN]
		},

		productListCount(){
			const count =  this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST]?.length
			if (count){
				return parseInt(count);
			}
			return 0
		},
		productTypeList(){
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_LIST];

		},
		productType() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE];
		},
		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];
		},

		outletLabel(){
			


			return "Outlet";
		}
		
	},
	watch:{

		'$route': {
			handler(to, from) {
				console.log('FP: route changed:', from.fullPath, 'to->', to.fullPath)
				if (this.sideMenuVisible){
					this.sideMenuVisible = false
				}
			},
			immediate: false,
			deep: false
		},

		productTypeLocal: function (productType) {
			console.log("FP: watcher: ", productType);
			/*
			this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType);
			this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);

			const searchModel =  this.$store.getters[STORE_GETTER.SEARCH_MODEL];

			this.$store.dispatch({ type: STORE_ACTION.SEARCH_PRODUCT_A, data: { productList: searchModel.productList } }).then(result => {
				console.log('FP: result: ', result);
				
				this.$store.commit(STORE_COMMIT.CREATE_MODEL);
				alert("productTypeLocal done");
			})*/

		},
		"productTypeModel.selected": {
			handler(productType) {
				console.log('FP: route: watch: productTypeModel.selected: ', productType);

				//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType);
				// FP: CO2:  this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
				this.$store.dispatch({ type: STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION}).then(() => {

					const searchModel = this.$store.getters[STORE_GETTER.SEARCH_MODEL];

					this.$store.dispatch({ type: STORE_ACTION.SEARCH_PRODUCT_A, data: { productList: searchModel.productList } }).then(result => {
						console.log('FP: result: ', result);

						this.$store.commit(STORE_COMMIT.CREATE_MODEL);
						//alert("search done");
						console.log('FP: router search done');

					})

				})

				
				

			}, 
		},
		/*'$route.params.productTypeKey': {

			handler: function (productTypeKey) {
				console.log("FP: watcher route: ", productTypeKey);

				const productType = this.productTypeModel?.list?.find(productType => productType.urlKey == productTypeKey?.toLowerCase());

				if (productType){
					//alert("$route.params.productTypeKey: " + productType.key)
					console.log('FP: route: watch: route.params.productTypeKey: ', productType);
					
					this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
					
				}

				//if (this.productId == null){
				//this.productId = productId
				//this.getProductDetails({ productId: this.productId });
				//}

			},
			immediate: true
		},*/
		/*productType: function (productType){
			console.log("FP: watcher productType: ", productType)
			alert("watch: productType: ", productType.key)

		}*/

	},
	methods: {
		reloadPressed(){
			console.log('FP: reloadPressed');

			if(this.$route?.name == "ProductDetails"){

				var productId = this.$route?.params?.productId;

				if (productId){
					productId = parseInt(productId);
					this.getProductDetails({ productId: productId });
				}
				
			}
			
			this.getBaseModel();
			this.getSearchIndexModel();
			this.getProductRowList();

		},

		sideMenuClosed(){
			if (!this.sideMenuVisible){
				this.$store.commit(STORE_COMMIT.SET_SIDE_MENU_KEY, null)
			}
		},


		getProductRowListFromRouterView(){
			console.log('FP: app getProductRowListFromRouterView()');
			
			this.getProductRowList();
		},
		getBaseModelFromRouterView() {
			console.log('FP: app getBaseModelFromRouterView()');

			this.getBaseModel();
		},
		hideSubMenu(name) {

			console.log('FP: hideSubMenu name: ', name);

			this.menuList.map(menu => {
				if (menu.name == name) {
					menu.visible = false;
				}

			})
		},
		hideAllSubmenu(value) {
			
			console.log('FP: hideAllSubmenu', value);

			if (!this.canHideAllSubMenu){
				//alert("kan inte dölja ")
				console.log('FP: hideAllSubmenu disabled');
				return;
			}

			this.menuList.map(menu => {
				menu.visible = false;
			})

			//alert("done");
		},

		showSubMenu(name) {

			console.log('FP: showSubMenu name: ', name);

			this.canHideAllSubMenu = false

			setTimeout(() => { this.canHideAllSubMenu = true  }, 1000); // skapar en timeout som gör att man inte kan stänga alla förens menyn blivit visad. 
			

			this.menuList.map(menu => {

				if (menu.name != name){ // FP: 2026 döljer inte den meny som ska öppnas om den är öppen. 
					menu.visible = false;
					console.log('FP: showSubMenu hide: ', menu.name);
				}
				
			})

			this.menuList.map(menu => {
				if (menu.name == name) {
					menu.visible = true;
					console.log('FP: showSubMenu show: ', menu.name);
				}

			})
		},
		toggleSubMenu(name) {
			if (this.isMenuVisible(name)) {
				this.hideSubMenu(name)
			} else {
				this.showSubMenu(name)
			}
		},
		closeMenus(currentMenu){ // FP: intern naviering

			if (this.sideMenuVisible){
				this.sideMenuVisible = false;
			}

			if (currentMenu){
				// om man vill filtera på en viss meny eller håll den öppen
			}

			if (!currentMenu){
				this.hideAllSubmenu();
			}



		},
		isMenuVisible(name) {
			if (name) {
				return this.menuList.filter(menu => menu.name == name && menu.visible).length > 0
			}

			return this.menuList.filter(menu => menu.visible).length > 0
		},

		toggleDebug() {
			this.$store.commit(STORE_COMMIT.TOGGLE_DEBUG);
			if (this.debug) {
				this.width = this.debugWidth;
			} else {
				this.width = this.defaultWidth;
			}
		},
		closeEventLogView() {
			this.$store.commit(STORE_COMMIT.SET_ALL_EVENTS_READ);
			this.hideAllSubmenu()
		},
		setAllMessagesRead() {
			this.$store.commit(STORE_COMMIT.SET_ALL_EVENTS_READ);
		},
		mouseMove() {

			this.isUserActive = true;

			if (this.$store.state.userActive) {

				var diff = (new Date().getTime() - this.$store.state.userActive.getTime()) / 1000;
				if (diff > 100) {
					console.log('FP: User was inactive: ', diff);
				}


				this.$store.commit("userIsActive");
			}

			clearTimeout(this.mouseTimer);
			this.mouseTimer = setTimeout(this.userInActive, 10 * 1000); // tio sekunder
		},
		userInActive() {

			/*this.$store.commit("userActive", false);
			clearTimeout(this.mouseTimer);
			this.mouseTimer = null;*/
			this.isUserActive = false;

			var diff = (new Date().getTime() - this.$store.state.userActive.getTime()) / 1000;
			console.log("FP: Mouse done, logout, inactive: ", diff);
		},
		productTypeChanged(event){
			const productType = event.target.value;

			console.log('FP: productTypeChanged: ', productType.key);
			
			alert("productTypeChanged: " + productType.key)
		},

		outletClicked(){
			


			if (this.$route.name === 'Products') {

				const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

				if (productType){


					const productGroupKey = "OUTLET_" + productType.name?.toUpperCase()

					const productGroup = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_GROUP_LIST]?.find(productGroup => productGroup.key == productGroupKey)

					if (productGroup){
						const searchProductConfig = this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];

						searchProductConfig.productGroupKey = productGroupKey

						this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)
						return;
					}

				}
			}

			this.gotoStart("start-outlet");


				
				

		},

		gotoStart(anchor){

			

			if (this.$route.name === 'StartView') {
				const element = document.getElementById(anchor);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' });
				}
			} else {

				const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

				if (productType?.urlKey){
					this.$router.push({ name: 'StartView', params: { productTypeKey: productType.urlKey }, hash: '#' + anchor }); 
				}else{
					this.$router.push({ name: 'StartView', hash: '#' + anchor }); 
				}
				
			}
		}


	},
	created() {
		console.clear()
		if (this.debug) {
			this.width = this.debugWidth
		}

		if (!this.baseModelLoading){ // FP: Här hämtas basemodel oavsett ingång till sidan. 
			this.getBaseModel();
		}


		if (!this.searchIndexModelLoading){ 
			this.getSearchIndexModel();
		}


	}
}
</script>

<style scoped>


div.site div#top-header{
	position: sticky;
	top:0px;
	z-index: 50;
}



div.site.login div#top-header {
	height: var(--top-header-height-login);
}

div.site.logout div#top-header {
	height: var(--top-header-height-logout);
}

div.site.logout div div#top-header div#nav{
	height:100%; 
}





div.site.login div div#top-header div#nav {
	height: 50%;
}

div#sideMenu {}

div#sideMenu.open {
	width: 80%;
	transition: all 0.3s ease;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
}

div#sideMenu.closed {
	width: 0%;
	transition: all 0.3s ease;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
	overflow: hidden;
}

/*
div#sideMenuBlur {}

html body div#app div div div#sideMenuBlur.open div#blur {
	
	background: rgba(0, 0, 0, 0.1);
	width: 100%;
	height: 100%;

	filter: blur(10px);
	-o-filter: blur(10px);
	-ms-filter: blur(10px);
	-moz-filter: blur(10px);
	-webkit-filter: blur(10px);

}*/


/*
		div.blurTEST {
	filter: blur(10px);
	-o-filter: blur(10px);
	-ms-filter: blur(10px);
	-moz-filter: blur(10px);
	-webkit-filter: blur(10px);
}
*/


/*
div#sideMenuBlur.open {
	width: 100%;
	transition: all 0.3s ease;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
}

div#sideMenuBlur.closed {
	width: 0%;
	transition: all 0.3s ease;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
	overflow: hidden;
}*/

div.site.login div.submenu{
	top: var(--top-header-height-login);
}

div.site.logout div.submenu {
	top: var(--top-header-height-logout);
}

div.site div.submenu {
	position: fixed;
	background: white;
	width: 100%;
	/*top: var(--top-header-height-logout);*/
	z-index: 40;
	/* blir någon bugg ibland annars */


}

div.site div.submenu.show {
	visibility: visible;
	opacity: 1;
	max-height: calc(100vh - 200px);
	overflow: scroll;
	transition: all 0.3s ease;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;


}

div.site div.submenu.hide {
	visibility: hidden;
	opacity: 0;
	max-height: 0;
	overflow: hidden;


	transition: all 0.3s ease 0.15s;
	-webkit-transition: all 0.3s ease 0.15s;
	-moz-transition: all 0.3s ease 0.15s;


}









html body div#app div.submenu {
	background: var(--white);
	/*padding-top: 10px; FP: ersätts nedan så man kan ha sticky i menyn */
	border-top:10px solid white;
	border-bottom: 10px solid white;
	padding-bottom: 30px;
}


/*
html body .desktop {
	display: initial;
}

.flexcenter.desktop {
	display: flex;
}

html body .mobile {
	display: none;
}
*/


@media (max-width: 768px) {


	/*html body div#app .desktop {
		display: none;
	}

	html body .mobile {
		display: initial;
	}
*/
	html body:has(.blur.blur-on),
	html body:has(.page-blur.blur-on) {
		overflow: hidden;
		position: fixed;
	}




}

div.menu-link.not-selected div {
	background: var(--bg-message);
}

div.menu-link.not-selected div{
	background:var(--grey-6); 
}


</style>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
/*@import url('https://fonts.googleapis.com/css?family=Roboto');*/
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;500;600;700;900&display=swap');

html{
}

html body {
	margin: 0px;
	padding: 0px;
	background: var(--white);
	color: black;
	height: 100%;
	font-size:15px;
	/* FP la till denna för att fixa produkt-detaljer popover */
}

/*
@media (max-width:768px) {
	html {
			overflow: hidden;
			height: 100%;
		}
	
		body {
			overflow: auto;
			height: 100%
		}
}*/



html body:has(.blur.blur-on),
html body:has(.page-blur.blur-on) {
	overflow: hidden;
}


div#app div div.center {

	max-width: v-bind("width");
	margin: 0 auto;


}

b {
	font-weight: 600;
}




div#app div div.center-padding {
	padding-left: 10px;
	padding-right: 10px;
}



h1,
h3,
h5,
p {
	padding: 0px;
	margin: 0px;
}
/*
h1 {
	font-size: 40px;
	color: #2B2B2B;

	;
}

h3 {
	font-size: 24px;
	color: #2B2B2B;
}

h5 {
	color: #6e6e73;

}*/

h1 {
	font-size: 2.2rem;
	color: #2B2B2B;
}

h3 {
	font-size: 1.3rem;
	color: #2B2B2B;
}

h5 {
	color: #6e6e73;
}

h1.condensed,
h3.condensed,
h1.cond,
h3.cond {
	font-family: "Roboto Condensed", Helvetica, Arial, sans-serif;
}

table thead th {
	text-align: left;
	;
}


#app {
	font-family: Roboto, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeLegibility;

}


#app textarea{
	font-family: Roboto, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

}

#app a {
	color: var(--font-color-darkest);

	text-decoration: none;
}

#app a:hover {
	text-decoration: none;
}

#nav a.router-link-exact-active {
	/*: black;*/
}

div#nav .menu-link{
	margin-left:15px;
}

@media (max-width:768px) {
	div#nav .menu-link {
			margin-left: 5px;
		}
}

.flexcenter {
	display: flex;
	align-items: center;
	column-gap: 2px;
}



div.flexheader {
	display: flex;
	align-items: center;
	column-gap: 2px;
	align-items: stretch;
	margin-bottom: 0px;
	max-height: 30px;
}


.badge {
	border-radius: 5px;

	background: var(--grey-button-bg);
	padding-left: 5px;
	padding-right: 5px;
	padding-top: 3px;
	padding-bottom: 3px;
	font-weight: bold;
	color: var(--font-color-light);
}



div.page-blur.blur-off,
div.blur.blur-off {
	background-color: rgba(255, 255, 255, 0);

	backdrop-filter: blur(0px);

	height: 0px;
	transition: all 0.3s ease 0s;

}

div.page-blur.blur-on,
div.blur.blur-on {
	background-color: rgba(160, 160, 160, 0.1);
	backdrop-filter: blur(15px) ;
	height: 2000px;
	transition: all 0.3s ease 0s;
}

.semi50 {
	background: rgba(0, 0, 0, 0.5);
}

.link,
.pointer {
	cursor: pointer;
}

img.spinning,
img.spinner {
	-webkit-animation: spin 1s linear infinite;
	-moz-animation: spin 1s linear infinite;
	animation: spin 1s linear infinite;
}

@-moz-keyframes spin {
	100% {
		-moz-transform: rotate(360deg);
	}
}

@-webkit-keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

/* fade-in fade-out */
div.fade.fade-in {
	visibility: visible;
	opacity: 1;
	transition: opacity 0.1s linear;
}

div.fade.fade-out {
	visibility: visible;
	opacity: 0;
	transition: visibility 0s 0.5s, opacity 0.5s linear;
}

/*
FP: <transition name="fade"><Circle v-if=""></div></transition> 
*/
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
	opacity: 1;
}


/* PAGE */
html body div#app div.page {
	background: transparent;
}

html body div#app div.site.logout div.page div.page-header {
	position: sticky;
	top: var(--top-header-height-logout);
	z-index: 20;
}

html body div#app div.site.login div.page div.page-header {
	position: sticky;
	top: var(--top-header-height-login);
	z-index: 20;
}

html body div#app div.page div.page-header .page-header-menu-show {
	background: var(--white);

}

html body div#app div.page div.page-header .page-header-menu-hide {
	background: var(--grey-bg);
}

html body div#app div.top-header-background.menu-show{
	background:var(--white);
}


html body div#app div.top-header-background.menu-hide {
	background: var(--grey-bg);
}


html body div#app div.page div.page-header .page-header-menu {
	height: 100%;
}




html body div#app div.page div.page-blur {
	z-index: 10;
	position: fixed;
	width: 100%;

}

html body div#app div.site div.page div.page-menu {
	background-color: var(--white);
	padding-bottom: 20px;
	position: fixed;
	/*top: calc(var(--top-header-height-logout) + var(--page-header-height));*/
	/* kan skrivas över */
	width: 100%;
	z-index: 7; /* var 100 */
}


html body div#app div.site.login div.page div.page-menu{
	top: calc(var(--top-header-height-login) + var(--page-header-height));
}

html body div#app div.site.logout div.page div.page-menu {
	top: calc(var(--top-header-height-logout) + var(--page-header-height));
}




html body div#app div.page div.page-menu.show {

	visibility: visible;
	opacity: 1;
	max-height: min(calc(100vh - 300px), 800px);
	overflow: scroll;
	transition: all 0.3s ease;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
}



html body div#app div.page div.page-menu.hide {
	visibility: hidden;
	opacity: 0;
	max-height: 0;
	overflow: hidden;
	transition: all 0.3s ease 0.15s;
	-webkit-transition: all 0.3s ease 0.15s;
	-moz-transition: all 0.3s ease 0.15s;
}




html body div#app div div.content {
	background: var(--white);
	color: #333333;
	padding: 0px;
	min-height: 300px;
	/*border-left: 1px solid var(--grey-4);*/
	/*border-right: 1px solid var(--grey-4);*/

}

/* /PAGE */

.lightest {
	background: var(--lightest);
}

.lighter {
	background: var(--lighter);
}

.light {
	background: var(--light);
}

.base {
	background: var(--base);
}

.dark {
	background: var(--dark);
}

.darker {
	background: var(--darker);
}

.darkest {
	background: var(--darkest);
}

div.drop-shadow {
	filter: drop-shadow(0px 5px 10px #777777);
}

div.drop-shadow-light {
	filter: drop-shadow(0px 5px 10px #a4a3a3);
}

/* stock */
div.noInStock.noInStock_OUT_OF_STOCK {
	background: var(--bg-error);
}

div.noInStock.noInStock_LOW_STOCK {
	background: var(--bg-warning);
}

div.noInStock.noInStock_IN_STOCK {
	background: var(--bg-ok);
}

.noInStockLabel.noInStock_OUT_OF_STOCK{
	color: var(--bg-error-solid);
}

.noInStockLabel.noInStock_LOW_STOCK {
color: var(--bg-warning-solid);
}

.noInStockLabel.noInStock_IN_STOCK {
color: var(--bg-ok-solid);
}

.font-normal {
	font-size: 1.0rem;
}

.font-small{
	font-size:0.9rem;
}

.font-smaller {
	font-size: 0.8rem;
}

.font-smallest{
	font-size: 0.75rem;
}

@media (max-width:768px) {
	.font-normal {
			font-size: 0.9rem;
		}
	
		.font-small {
			font-size: 0.8rem;
		}
	
		.font-smaller {
			font-size: 0.75rem;
		}
	
		.font-smallest {
			font-size: 0.75rem;
		}
}


/* Generella färger */
:root {
	--bg: #242526;
	/* 333333 */
	--bg-ok: linear-gradient(#014506, #015a07);
	--bg-ok-light: linear-gradient(#078611, #037e0b);
	--bg-ok-dark: linear-gradient(#014105, #024206);
	--bg-ok-solid: #015a07;

	--bg-message-light: linear-gradient(#4a87f9, #0c5ef4);
	--bg-message: linear-gradient(#094fd1, #0c5ef4);
	--bg-message-dark: linear-gradient(#113f94, #0c337b);
	--bg-message-solid: #0c5ef4;

	--bg-warning-light: linear-gradient(#f9780e, #f9ad0a);
	--bg-warning: linear-gradient(#ce6005, #f37107);
	--bg-warning-dark: linear-gradient(#792c03, #a63b04);
	--bg-warning-solid: #f37107;

	--bg-error-light: linear-gradient(#fb472c, #f74e4e);
	--bg-error: linear-gradient(#d80c0c, #f03a3a);
	--bg-error-dark: linear-gradient(#830606, #a61010);
	--bg-error-solid: #f03a3a;

		--bg-discount: linear-gradient(#094fd1, #0c5ef4);

	--lightest: #888888;
	--lighter: #666666;
	--light: #454545;
	--base: #333333;
	--base-light: white;
	--dark: #242526;
	--darker: #161616;
	--darkest: #000000;

	--darkest: #000000;

	--bg-debug-light: #0da5aa;
	--bg-debug: #087579;
	--bg-debug-dark: #07595c;

	--font-color-light: white;
	--font-color-grey: #808080;
	--font-color-grey-light: #a3a0a0;
	--font-color-darkest: #333333;
	--font-color-darker: #5b5a5a;
	--font-color-dark: #797878;
	--font-color-outlet: rgb(236, 16, 16);


	--grey-1: #fafafa;
	--grey-2: #f5f5f5;
	--grey-3: #eeeeee;
	--grey-4: #e0e0e0;
	--grey-5: #bdbdbd;
	--grey-6: #9e9e9e;

	--grey-dark-1: #757575;
	--grey-dark-2: #616161;
	--grey-dark-3: #424242;
	--grey-dark-4: #212121;

	--bg-white: #ffffff;
	--bg-light: #bdbdbd;
	--bg-grey: #666666;
	--bg-dark: #2b2b2b;
	--bg-black: #000000;

	--white: #ffffff;
	--grey-bg: #f6f6f6;

	--grey-button-bg: #6e6e73;

	--top-header-height-logout: 50px;
	--top-header-height-login: 100px;
	--page-header-height: 50px;
	--order-header-height: 50px;

	--padding: 10px;
	--padding-tight: 5px;
	--padding-tighter: 3px;

	--margin: 10px;
	--margin-tight: 5px;
	--margin-tighter: 3px;
}

/* auto-justeringar desktop/mobile */

div.padding-top-auto {
	padding-top: 10px;
}

div.margin-top-auto {
	margin-top: 10px;
}

div.padding-auto {
	padding: 10px;
}

div.margin-auto {
	padding: 10px;
}

@media (min-width: 1420px) { /* 1400 + 20 */
		div#app div div.center-padding {
				padding-left: 0px;
				padding-right: 0px;

				
		
			}
}

html body .desktop {
	display: initial;
}

.flexcenter.desktop {
	display: flex;
}

html body .mobile {
	display: none;
}

@media (max-width: 768px) {

	:root {
		/* FP: IOS-Fix
		--top-header-height-logout: 40px;
		--top-header-height-login: 80px;
		--order-header-height: 40px;
		--page-header-height: 40px;*/

		--top-header-height-logout: 50px;
		--top-header-height-login: 90px;
		--order-header-height: 50px;
		--page-header-height: 50px;
					

		--padding: 5px;
		--padding-tight: 3px;
		--padding-tighter: 2px;
		--margin: 5px;
		--margin-tight: 3px;
		--margin-tighter: 2px;
	}

	div#app div div.center-padding {
		padding-left: 5px;
		padding-right: 5px;

	}

	/* FP: IOS-Fix div.padding-top-auto {
		padding-top: 5px;
	}*/
	div.padding-top-auto {
		padding-top: 10px;
	}

	div.padding-auto {
		padding: 5px;
	}

	div.margin-top-auto {
		margin-top: 5px;
	}

		html body div#app .desktop {
			display: none;
		}
	
		html body .mobile {
			display: initial;
		}


}

/* dropdown */

div.dropdown{
	border:0px solid red;
	position: absolute;
	padding: 5px;
	border-radius: 5px;
	overscroll-behavior: contain;
}

div.dropdown-w200 {
	width: 200px;
}

div.dropdown-w300{
	width: 300px;
}

div.dropdown-w400 {
	width: 400px;
}

div.dropdown-p10 {
	padding: 10px;
}

div.dropdown-h400 {
	height: 400px;
}

div.dropdown-shadow{
filter: drop-shadow(0px 2px 10px #777777);
}

@media (max-width: 768px){
div.dropdown {
		border: 0px solid orange;
		position: absolute;
		background: var(--grey-3);
		width: calc(100vw - 30px);
		border-radius: 5px;
		left:5px;
		max-height:calc(100vh - 50px); /* FP: lite marginal... */
	}

div.dropdown-w200, div.dropdown-w300, div.dropdown-w400 {
	width: calc(100vw - 20px);
}

div.dropdown-p10 {
	padding: 5px;
}

div.dropdown-h400{
	height:calc(60vh - 0px); /* padding från bottom */
	max-height: calc(100vh - 350px);
	border-bottom:0px solid red;
	
}

}


.outlet-price{
	color:var(--font-color-outlet);
}

/* dataTable
*/
table.dataTable {
	text-align: left;
	border-collapse: separate;
	border-spacing: 0px;
	width: calc(100% - 2px);
}

table.dataTable thead tr th {
	text-align: left;
	position: sticky;
	top: 0px;
}


table.dataTable thead tr th {
	padding: 0px;
}

table.dataTable thead tr th div {
	padding: 10px;
	background: var(--darkest);
	height: 100%;
	border: 1px solid var(--lighter);
	border-left: 0px;
	border-top: 0px;
	color: white;
}

table.dataTable thead tr th:last-child div {
	border-right: 0px;
}

table.dataTable tbody tr td {
	padding: 5px;
	border: 1px solid var(--lighter);
	border-left: 0px;
	border-top: 0px;
	color: var(--font-color-darkest);
}

table.dataTable tbody tr td:last-child {
	border-right: 0px;
}

table.dataTable tbody.odd tr:hover td,
table.dataTable tbody tr:hover td {
	background: var(--dark);
	background: transparent;
}

table.dataTable tbody tr.expanded td {
	background: var(--darkest);
	background: transparent;
}

table.dataTable tbody.odd tr {
	background: var(--grey-1);
	background: var(--grey-3);
}

table.dataTable tbody tr {
	background: var(--base);
	background: transparent;
}

/* debug */
div.debug {
	background: var(--bg-debug);
	color:white;
	padding: 5px;
	border-radius: 5px;
	margin-left: 5px;
	margin-right: 5px;
}

/* form */
div.form.textField {
	background: var(--white);
	display: flex;
	align-items: center;
	border-radius: 5px;
	padding: 3px;
	max-height: 30px;
	border: 1px solid var(--grey-6);
}

div.form.textarea {
	background: var(--white);
	display: flex;
	align-items: center;
	border-radius: 5px;
	padding: 5px;
	padding-top:10px;
	padding-bottom:10px;
	max-height: 30px;
	border: 1px solid var(--grey-6);
}

div.form.textarea textarea{
	background:transparent; 
	width:100%;
	border:0px solid transparent;
	outline: none;

}


div.form.textField input[type=text],
div.form.textField input[type=password] {
	padding: 3px;
	width: 100%;
	background: transparent;
	color: black;
	border: 0px;
	padding-left: 5px;
	outline: none;

}

div.form.textField img {
	max-height: 20px;
	max-width: 20px;
	height: 100%;
	width: auto;
}

select.form.select {
	background: var(--dark);
	border: 0px solid transparent;
	border-radius: 5px;
	color: white;
	padding-left: 5px;
}

div.footer {
	background: #2b2b2b;
	min-height: 300px;
	color: white;
	padding-top: 10px;
}

div.footer h1,
div.footer h3,
div.footer h5 {
	color: white;
}

/* noInStock */
div.noInStock_OUT_OF_STOCK{
	background:var(--bg-error);
}

/* input mobilen */
input {
	font-size: 14px;
}

@media (max-width: 768px) {
	input {
		font-size: 16px;
	}
}


</style>
